// @docs:
//   - docs/core/architecture/PASSAGEWIKI_SITE.md
// PassageWiki moderation — reports users file against a public passage.
// The reason list mirrors REPORT_REASONS in vortex-api/src/services/navService.ts
// and the labels match what the reporter saw on passagewiki.com.

export type PassageReportReason = 'hazard' | 'inaccurate' | 'stale' | 'copyright' | 'inappropriate' | 'other';
export type PassageReportStatus = 'open' | 'resolved' | 'dismissed';

export const PASSAGE_REPORT_REASON_LABEL: Record<PassageReportReason, string> = {
  hazard: 'Hazard — could put someone on the rocks',
  inaccurate: 'Inaccurate',
  stale: 'Out of date',
  copyright: 'Copied from a chart or guide',
  inappropriate: 'Inappropriate',
  other: 'Something else',
};

export interface PassageReport {
  id: string;
  elementId: string;
  elementName: string | null;
  elementType: 'route' | 'track' | 'waypoint' | null;
  /** Still in the commons? False once an admin withdrew it, or the owner unpublished. */
  elementIsPublic: boolean | null;
  ownerName: string | null;
  reporterUserId: string;
  reporterName: string | null;
  reporterEmail: string | null;
  reason: PassageReportReason;
  details: string | null;
  status: PassageReportStatus;
  resolutionNote: string | null;
  resolvedByUserId: string | null;
  createdAt: string | null;
  resolvedAt: string | null;
}
